module.exports = __webpack_public_path__ + "static/media/woman.4dd543dd.jpg";